import { useEffect, useState } from "react";

import YouTube from "react-youtube";

import { opts } from "@/lib/constants";
const VideoModule = ({ title, url }) => {
  const [videoId, setVideoId] = useState("");

  useEffect(() => {
    const extractVideoId = (url) => {
      if (url.includes("youtu.be/")) {
        const parts = url.split("/");
        const id = parts[parts.length - 1].split("?")[0];
        return id;
      }
      if (url.includes("youtube.com/watch")) {
        const params = new URLSearchParams(url.split("?")[1]);
        return params.get("v");
      }
      return null;
    };

    const id = extractVideoId(url);
    setVideoId(id);
  }, []);

  return (
    <div className="mt-24 stock-container markdown-content">
      <h2 className="why-title mt-0 mb-8 h4-style">{title}</h2>
      <p className="stock-newScore fs-16 text-start mb-24">
        This is the latest video review on this stock.
      </p>
      <YouTube videoId={videoId} opts={opts} />
    </div>
  );
};

export default VideoModule;
